import { gql } from 'apollo-boost';

// input DeleteUserInput {
// 	userId: String!
//  email: String!
// }

export const DELETE_USER_ADMIN = gql`
    mutation($data: DeleteUserInput!) {
        deleteUserAdmin(data: $data) {
            __typename
            ... on User {
                id
                email
                deletedAt
            }
            ... on InternalServerError {
                message
            }
            ... on DbStartTransactionError {
                message
            }
        }
    }
`;
